var map = {
	"./Bowls and cups.png": 48,
	"./Collars.png": 49,
	"./Medicines.png": 50,
	"./Pet food.png": 51,
	"./Shampoos.png": 52,
	"./Sleeping area.png": 53,
	"./Toys.png": 54,
	"./Transportation.png": 55,
	"./Vitamins.png": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;